export const Title = (p: { children: string }) => (
  <h1 className="text-3xl font-bold">{p.children}</h1>
);
